import { ObservationDocument } from "../../observations-context"
import { INIT_AGGREGATED_OBSERVATIONS } from "../index"

export default (data: ObservationDocument[]) => {
    const seenSpecies = new Set()

    return data.reduce((acc, curr) => {
        let count = 0
        if (curr.type === "feeding")
            (curr as ObservationDocument<"feeding">).items.forEach(item => {
                if (!seenSpecies.has(item.species)) count++
                seenSpecies.add(item.species)
            })

        return {
            visits: curr.type === "entry" ? ++acc.visits : acc.visits,
            feedTypes: acc.feedTypes + count,
            triggers: acc.triggers + 1,
        }
    }, INIT_AGGREGATED_OBSERVATIONS)
}
